import {faCircleInfo} from '@fortawesome/pro-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Text} from '@rdcomponents/text/text';
import {Flex, Form, Tooltip} from 'antd';

import {spacer_xs} from '../../../../../css/var-export.scss';
import {Locale} from '../../../../../provider/locale/localization';
import {ReviewTagsSelect} from '../../review-tags-select/review-tags-select';

import {ImportReviewsFormFieldNamesEnum, ImportReviewsFormFieldsType} from './import-reviews-form-type';
import * as styles from './import-reviews-tags-field.module.scss';

export function ImportReviewsTagsField(): JSX.Element {
    return (
        <Form.Item<ImportReviewsFormFieldsType>
            className={styles.ImportReviewsTagsField_formItemRoot}
            colon={false}
            label={
                <Flex align="center" gap={spacer_xs} wrap="wrap">
                    <Text large lighter stringKey="REVIEWS__FILTER__LABEL__TAGS" />
                    <Tooltip title={<Locale stringKey="REVIEW_IMPORT__TAGS_TOOLTIP" />}>
                        <span className={styles.ImportReviewsTagsField_infoIconWrap}>
                            <FontAwesomeIcon icon={faCircleInfo} />
                        </span>
                    </Tooltip>
                </Flex>
            }
            name={ImportReviewsFormFieldNamesEnum.tags}
        >
            <ReviewTagsSelect />
        </Form.Item>
    );
}
